module.exports = __webpack_public_path__ + "static/media/people.a6f70882.jpg";